import React, { useEffect, useState } from 'react';
import { Box, Collapse, LinearProgress, IconButton } from '@mui/material';
import { ReactComponent as ArrowRight } from 'src/Images/icons/common/arrowright.svg';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';
import { ReactComponent as ErrorAlert } from 'src/Images/icons/common/error-sync-circle.svg';

export default function ErrorToast({ id, message, errorList, onClose }) {
  const [remainingCloseTime, setRemainingCloseTime] = useState(10000);
  const [expandToaster, setExpandToaster] = useState(false);
  const [closeToaster, setCloseToaster] = useState(false);

  const closeToast = (delay) => {
    setCloseToaster(true);
    setTimeout(() => onClose(id), delay);
  };

  const handleManualClose = () => closeToast(600);
  const handleAutoClose = () => closeToast(800);

  useEffect(() => {
    if (expandToaster || closeToaster) return undefined;

    if (remainingCloseTime <= 0) {
      handleAutoClose();
      return undefined;
    }

    const timer = setTimeout(() => {
      setRemainingCloseTime((prev) => prev - 100);
    }, 100);

    return () => clearTimeout(timer);
  }, [expandToaster, remainingCloseTime, closeToaster]);

  return (
    <Box
      sx={{
        background: '#ffff',
        borderRadius: '6px',
        border: '1px solid #dbdbdb',
        overflow: 'hidden',
        boxShadow:
          '0 12px 40px rgba(0,0,0,0.015), 0 24px 80px rgba(0,0,0,0.01)',
        opacity: closeToaster ? 0 : 1,
        transform: closeToaster ? 'translateX(20px)' : 'translateX(0)',
        transition: 'opacity 600ms ease, transform 600ms ease',
      }}
    >
      <Box
        sx={{
          padding: '4px 8px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div className="div-flex-row cg-5 div-align-center">
          <ErrorAlert className="icon-size-sm" />
          <div className="text-sm text-semi-bold">{message}</div>
        </div>
        <Box>
          <IconButton
            size="small"
            onClick={() => setExpandToaster(!expandToaster)}
          >
            <ArrowRight
              className="icon-size-sm"
              style={{
                transform: expandToaster ? 'rotate(-90deg)' : 'rotate(90deg)',
              }}
            />
          </IconButton>
          <IconButton size="small" onClick={handleManualClose}>
            <Close className="icon-size-sm" color="grey" />
          </IconButton>
        </Box>
      </Box>

      <Collapse in={expandToaster}>
        <Box sx={{ padding: '8px', background: '#f8f8f8' }}>
          {errorList &&
            Object.entries(errorList).map(([field, messages]) => {
              const jsonLine = JSON.stringify({ [field]: messages });
              return (
                <div key={`${id}-${field}`} className="text-sm text-grey">
                  {jsonLine}
                </div>
              );
            })}
        </Box>
      </Collapse>

      <LinearProgress
        variant="determinate"
        value={(remainingCloseTime / 10000) * 100}
        sx={{
          height: '4px',
          bgcolor: '#FCE6E7',
          '& .MuiLinearProgress-bar': { backgroundColor: '#D62824' },
        }}
      />
    </Box>
  );
}
